/* eslint-disable no-magic-numbers */
import {
  type Contract,
  type Contractor,
  ContractState,
  type InvoicingCurrencyEnum,
  LiabilityShieldState,
} from '@omnipresentgroup/types';

export const getContractorActiveContract = (
  contractor: Contractor,
): Contract | undefined =>
  contractor?.contracts?.filter((c) => c.state === ContractState.ACTIVE)[0];

export const getContractorCurrency = ({
  contractor,
  fallback,
}: {
  contractor?: Contractor;
  fallback: InvoicingCurrencyEnum;
}): InvoicingCurrencyEnum =>
  contractor
    ? getContractorActiveContract(contractor)?.invoicingCurrency || fallback
    : fallback;

export const isLiabilityShieldActiveInContract = (contract: Contract) =>
  contract.liabilityShieldCoverages?.some(
    (lsc) => lsc.state === LiabilityShieldState.ACTIVE,
  );

export const isLiabilityShieldInactiveInContract = (contract: Contract) =>
  contract.liabilityShieldCoverages?.every(
    (lsc) => lsc.state === LiabilityShieldState.INACTIVE,
  );
